// Drop-in replacement for vue-error-page: registers the <app-view> wrapper and
// $_error. $_error(name, payload) swaps the routed view for the resolved error
// component until the next route change.
import { h } from 'vue'
import { RouterView } from 'vue-router'
import eventBus from '@/shared/eventBus'

export default {
    install(app, {
        tagName = 'app-view',
        event = 'error-page',
        resolver = (component) => component,
    } = {}) {
        app.config.globalProperties.$_error = (component, payload = {}) => {
            eventBus.$emit(event, { component, payload })
        }

        app.component(tagName, {
            name: 'AppView',
            data() {
                return {
                    errorComponent: null,
                    payload: null,
                }
            },
            watch: {
                $route() {
                    this.errorComponent = null
                    this.payload = null
                },
            },
            created() {
                eventBus.$on(event, ({ component, payload }) => {
                    this.errorComponent = resolver(component)
                    this.payload = payload
                })
            },
            render() {
                if (this.errorComponent) {
                    return h(this.errorComponent, this.payload || {})
                }
                return h(RouterView)
            },
        })
    },
}
